import type { AmplitudeInitModel } from '@cw-elements/analytics-provider';

import { ENV_VARIABLES } from '@/constants';

import { AMPLITUDE_DISABLED_MESSAGE } from './constants';

/**
 * Builds the Amplitude block for the analytics provider's `initAnalytics`, or
 * `undefined` when no client id is configured — Amplitude is expected to be off
 * in local development, so a missing id is a warning rather than a failure.
 */
const getAmplitudeConfig = (): AmplitudeInitModel | undefined => {
  if (!ENV_VARIABLES.AMPLITUDE_ID) {
    console.warn(AMPLITUDE_DISABLED_MESSAGE);

    return undefined;
  }

  return {
    clientId: ENV_VARIABLES.AMPLITUDE_ID,
    autocapture: false
  };
};

export default getAmplitudeConfig;
